import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ComponentService {
  currentComponent: string;
  currentComponentChanged: EventEmitter<string> = new EventEmitter<string>();
}
